import { useState } from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogTitle,
} from "@/components/ui/dialog";
import { SaveButton } from "@/components/ui/save-button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const StatusSwatch = ({ event }) => (
  <span className="tw:inline-flex tw:items-center tw:gap-1.5">
    {event.color && (
      <span
        className="tw:inline-block tw:size-2 tw:rounded-full"
        style={{ backgroundColor: event.color }}
      />
    )}
    {event.name}
  </span>
);

const StatusPicker = ({
  events,
  currentStatusId,
  cancelVariant,
  onConfirm,
  onClose,
}) => {
  const [statusId, setStatusId] = useState(currentStatusId ?? null);
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    try {
      await onConfirm(statusId);
      onClose();
    } catch {
      // onConfirm surfaces failures via toast; keep the dialog open to retry.
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <Select value={statusId} onValueChange={setStatusId}>
        <SelectTrigger aria-label="Status" className="tw:w-full">
          <SelectValue placeholder="Select a status…">
            {value => {
              const selected = events.find(event => event.id === value);
              return selected ? (
                <StatusSwatch event={selected} />
              ) : (
                "Select a status…"
              );
            }}
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          {events.map(event => (
            <SelectItem key={event.id} value={event.id}>
              <StatusSwatch event={event} />
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <DialogFooter>
        <Button variant={cancelVariant} onClick={onClose} disabled={saving}>
          Cancel
        </Button>
        <SaveButton
          onClick={handleSave}
          saving={saving}
          disabled={statusId == null}
        />
      </DialogFooter>
    </>
  );
};

const ChangeLeadStatusModal = ({
  events = [],
  title = "Change Status",
  currentStatusId,
  cancelVariant = "outline",
  open,
  onOpenChange,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogTitle>{title}</DialogTitle>
        <DialogDescription>
          The status is sent to Meta only when Reports to Meta is turned on for
          it in Settings, under Meta Leads Events.
        </DialogDescription>
        {open && (
          <StatusPicker
            events={events}
            currentStatusId={currentStatusId}
            cancelVariant={cancelVariant}
            onConfirm={onConfirm}
            onClose={() => onOpenChange(false)}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ChangeLeadStatusModal;
